import { render, staticRenderFns } from "./BlogHome.vue?vue&type=template&id=00f1526c&scoped=true"
import script from "./BlogHome.vue?vue&type=script&lang=js"
export * from "./BlogHome.vue?vue&type=script&lang=js"
import style0 from "./BlogHome.vue?vue&type=style&index=0&id=00f1526c&prod&lang=scss&scoped=true"
import style1 from "./BlogHome.vue?vue&type=style&index=1&id=00f1526c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f1526c",
  null
  
)

export default component.exports